/**
 * design_handoff_auth §2 — split layout used by Log in and Create account.
 * Right pane is decorative and collapses entirely below 900px; it must
 * never hold anything required to log in or sign up.
 */
import React from "react";
import AuthColumn from "./AuthColumn";
import styles from "./AuthLayout.module.scss";

const AuthLayout = ({ rightPane, mobileExtra, children }) => {
  return (
    <div className={styles.page}>
      <AuthColumn mobileExtra={mobileExtra}>{children}</AuthColumn>
      <aside className={styles.right}>{rightPane}</aside>
    </div>
  );
};

export default AuthLayout;
